import { Box, Typography, useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import Pagination from '@mui/material/Pagination';
import Select, { type SelectChangeEvent } from '@mui/material/Select';
import { strings } from 'i18n/Strings';
import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
  setCurrentPage,
  type PageType,
  setRowsPerPage,
} from 'store/component/pagination';
import { colorTheme } from 'theme';

interface CustomPaginationProps {
  rowsPerPageOptions: number[];
  currentPage: PageType;
  totalCount: number;
}

const CustomPagination = ({
  rowsPerPageOptions,
  currentPage,
  totalCount,
}: CustomPaginationProps): JSX.Element => {
  const pageInfo = useSelector((state) => state?.pagination[currentPage]);
  const page = pageInfo?.page;
  const pageCount = Math.ceil(totalCount / pageInfo?.pageSize);
  const currentTheme = useTheme();
  const colors = colorTheme(currentTheme.palette.mode);
  const dispatch = useDispatch();

  const handlePageChange = (
    event: React.ChangeEvent<unknown>,
    value: number,
  ): void => {
    dispatch(setCurrentPage({ key: currentPage, value: value - 1 }));
  };
  const handleRowsPerPageChange = (
    event: SelectChangeEvent<number>, // Change event type
  ): void => {
    dispatch(
      setRowsPerPage({ key: currentPage, value: Number(event.target.value) }),
    );
    dispatch(setCurrentPage({ key: currentPage, value: 0 }));
  };

  return (
    <Box
      flex={1}
      display="flex"
      justifyContent="space-between"
      alignItems="center"
    >
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography
          variant="h5"
          color={colors.gray[100]}
          fontSize={14}
          marginTop={1}
        >
          Showing
        </Typography>
        <Select
          labelId="rows-per-page-label"
          id="rows-per-page"
          value={pageInfo?.pageSize}
          defaultValue={pageInfo?.pageSize}
          onChange={handleRowsPerPageChange}
          sx={{
            marginX: 1,
            maxHeight: 35,
            minHeight: 35,
            minWidth: 60,
            maxWidth: 60,
            marginTop: 1.5,
          }}
        >
          {rowsPerPageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
                {option}
              </Typography>
            </MenuItem>
          ))}
        </Select>
        <Typography
          variant="h6"
          color={colors.gray[600]}
          fontSize={13}
          marginTop={1}
        >
          {strings.displayText.itemsPerPage}
        </Typography>
      </Box>
      <Pagination
        color="primary"
        count={pageCount}
        page={Number(page) + 1}
        variant="outlined"
        shape="rounded"
        onChange={handlePageChange}
      />
    </Box>
  );
};

export default CustomPagination;
